<template>
  <div class="mb-8 flex flex-col gap-y-2.5">
    <div
      class="w-full px-5 py-4 border border-green-900/50 bg-green-900/5 rounded-md"
    >
      <div class="flex items-center justify-between">
        <div class="font-semibold font-primary text-[18px] leading-[20px] mb-2">
          {{ selectedPlan?.name }} plan
        </div>
        <div
          class="font-secondary text-[14px] leading-[20px] text-link"
          @click="emit('change')"
        >
          Change
        </div>
      </div>
      <div class="font-secondary text-[14px] leading-[20px] font-medium">
        <div>{{ selectedBillingCycle.description }}</div>
        <div class="flex">
          <div v-for="(price, index) in selectedPlanItem?.prices" :key="index">
            <span class="mr-0.5">{{ getBillingCyclePrice(price) }}</span>
            <span v-if="!index">
              <span>/{{ selectedBillingCycle.type }}</span>
              <span v-if="hasMoreThanOnePrice" class="mr-1"> + </span>
            </span>
            <span v-else>/copyright</span>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="selectedPlanItem?.upsell"
      class="w-full flex flex-col border border-green-700/25 bg-green-200/25 px-5 py-2.5 rounded-md font-secondary text-[14px] leading-[20px] text-gray-500 mb-[18px] font-medium gap-y-1.5"
    >
      <div class="flex items-center justify-between">
        <Pill class="mr-[15px]" success>
          {{ selectedPlanItem.upsell.pillText }}
        </Pill>
        <div class="text-link" @click="emit('upgrade')">Apply upgrade</div>
      </div>
      {{ formatUpsellText(selectedPlanItem.upsell?.text) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type {
  Plan,
  PlanItem,
  PlanPriceItem,
} from '@/shared/graphql/legacy/generated'
import { Pill } from '@dacr/ui'

defineProps<{
  selectedPlan?: Plan
  selectedPlanItem?: PlanItem
  selectedBillingCycle: { type: string; description: string }
  hasMoreThanOnePrice: boolean
  getBillingCyclePrice: (price: PlanPriceItem) => string
  formatUpsellText: (text?: string) => string | undefined
}>()

const emit = defineEmits<{
  (e: 'change'): void
  (e: 'upgrade'): void
}>()
</script>
